<template>
  <transition name="fade" mode="out-in">

    <div class="animated fadeIn form-mimoto">

    <CRow class="mb-4">
      <CCol md="12">
        <h5 class="subtitle mb-1">{{ step }}. Pasarela de pago</h5>
        <p class="mb-3 text-primary">Pulsa Pagar para confirmar el pedido</p>
      </CCol>
    </CRow>


    <ConfirmationModal
      v-bind:show.sync="showModalAddCard"
      title="Añadir método de pago"
      @cancel="showModalAddCard = $event"
      @confirm="newCreditCard"
    >
      <!-- <h3>Añadir método de pago</h3> -->
      <!-- Para poder añadir o cambiar su tarjeta de crédito,  -->
      <p> Para poder añadir su tarjeta de crédito, pasará a la pasarela del banco para añadir sus datos con la mayor seguridad y conforme a la regulación vigente.</p>

      <p v-if="!NOACCESS" class="text-primary">* Una vez completado el proceso volverá a su área personal</p>
      <small v-else class="text-primary">* Una vez completado el proceso le llegará un email su pin de acceso</small>
    </ConfirmationModal>


    <CCard>
      <CCardBody borderColor="primary">


        <CRow class="d-flex justify-content-center align-items-start">
          <CCol sm="5" md="5" lg="5">

            <p v-if="clientCards > 0" class="mb-3 text-primary">Selecciona un método de pago.</p>
            <CListGroup flush class="mb-4">
                <CListGroupItem  v-for="(card) in clientCards" :key="card.id"
                class="d-flex justify-content-start align-items-center">

                <span>
                  <CInputRadio
                  :checked.sync="card.checked"
                  :disabled="card.expired"
                  name="card-radios"
                  custom
                  @update:checked="() => setCard(card)"
                  />
                </span>

                <span class="ml-4">
                  <CIcon name="cil-credit-card" />
                  <span v-if="card.expired" class="text-danger"> Caducada el  {{ card | card_date }}</span>
                  <span v-else> <span v-if="card.last4"> Tarjeta acabada en</span> {{ getCardLast4(card) }}</span>
                </span>

                </CListGroupItem>
            </CListGroup>

            <p class="mb-3 text-primary" >
              <a @click="showModalAddCard = true"
                v-c-tooltip.hover.click="'Pulsa para añadir una nueva tarjeta'"
                style="cursor:pointer;" >
                <CIcon style="font-weight: 700" name="cil-plus" />
                  Añadir método de pago.

              </a>
            </p>

          </CCol>

          <CCol sm="9" md="9" lg="7" class="h-100 checkout-by-steps-sidebar__content ">
            <!--  px-4 -->

              <CRow>
                <CCol sm="12" style="margin-bottom: 2.4rem">
                  <article>
                    <CRow>
                      <CCol sm="12">

                        <strong class="mb-1">Duración: </strong>

                        <!-- <p v-if="product && product.longitude_value">{{ Number(product.longitude_value / 1000).toFixed(1)}} Km </p> -->
                        <p v-if="product">{{ parkingPlan.plan.duration }} </p>

                      </CCol>

                      <CCol sm="12">
                        <CCardGroup deck>

                          <CCard>
                            <CCardHeader color="gradient-primary" class="text-white">Inicio </CCardHeader>
                            <CCardBody>
                             <span v-if="product.start_datetime">{{ product.start_datetime | DateSimple }} - {{ product.start_datetime | Timeh }} h </span>
                             <span v-else><spinner-ttt :show="!product.start_datetime"/></span>
                            </CCardBody>
                          </CCard>

                          <CCard>
                            <CCardHeader color="gradient-dark" class="text-white" >Fin</CCardHeader>
                            <CCardBody>

                              <span v-if="product.end_datetime">{{ product.end_datetime | DateSimple }} - {{ product.end_datetime | Timeh }} h </span>
                              <span v-else><spinner-ttt :show="!product.end_datetime"/></span>
                            </CCardBody>
                          </CCard>
                        </CCardGroup>
                      </CCol>

                      <CCol sm="12" class="mt-3">
                        <span v-if="price_hour"> La facturación del estacionamiento, una vez finalice el PLAN se realizará por precio por minuto, mínimo una hora
                        ({{ price_hour }} €)</span><span v-if="parking">. Máximo por 24h ({{parking.max_daily_amount}} €)</span>
                      </CCol>

                    </CRow>

                  </article>
                </CCol>



                <CCol sm="12" >

                  <!-- <article class="cart__checkout">

                    <CAlert color="danger" v-if="!cuponValid && cuponError"  class="alert-space" style="padding: 1.6rem;">
                     El cupón introducido no es válido </CAlert>

                    <CRow>
                      <CCol sm="7" md="8">
                        <CInput type="text" name="coupon" placeholder="Código de descuento"
                        v-model="cuponDescuento" v-on:keypress.enter="applyCoupon"/>
                      </CCol>

                      <CCol sm="5" md="4">
                        <CButton  @click="applyCoupon" square color="dark" class="w-100">Usar</CButton>
                      </CCol>
                    </CRow>

                  <div class="mt-2">
                    <CListGroupItem v-for="(coupon) in clientCoupons"
                    :key="coupon.id" class="d-flex justify-content-between align-items-center ">

                      <span>{{coupon.code }}</span>

                      <span>
                        <small >Válido hasta</small>
                        {{coupon.end_datetime |  DateSimple}}
                      </span>

                    </CListGroupItem>
                  </div>

                  <div v-if="cuponValid" class="mt-2 text-primary text-right">
                    Cupón aplicado <strong> {{ coupon.code }} </strong>
                  </div>

                  </article> -->

                  <article class="cart__checkout" v-if="client">
                    <CRow class="checkout-by-steps-cart-price ">
                      <CCol sm="4" md="5">Subtotal</CCol>
                      <CCol sm="8" md="7">
                        <p v-if="product" class="text-right" style="font-weight: 700; font-size: 1rem;"
                        :style="cuponValid ? 'text-decoration: line-through' : ''"
                        >
                          {{ product.amount ? product.amount : 0 | toFixedNoRounding }} €
                        </p>
                      </CCol>
                    </CRow>

                    <CRow class="checkout-by-steps-cart-price ">
                      <CCol sm="4" md="5">Descuento <span v-if="client.group"> {{ client.group.name }}</span></CCol>
                      <CCol sm="8" md="7">
                        <p
                        class="text-right"
                        style="font-weight: 600; font-size: 1rem;">
                        <span v-if="product && cuponValid"> {{ product.discount_amount ? product.discount_amount : 0 | toFixedNoRounding }} € </span>
                        <span v-else-if="product">{{ 0 | toFixedNoRounding }} €</span>
                      </p>
                      </CCol>
                    </CRow>
                  </article>

                  <!-- <h5><strong class="text-primary">Total a pagar</strong></h5> -->
                  <article class="cart__checkout">
                     <CRow class="checkout-by-steps-cart-price checkout-by-steps-cart-price--total">
                      <CCol sm="4" md="5">Total</CCol>
                      <CCol sm="8" md="7" v-if="product" class="d-flex justify-content-end align-items-end">
                        <p class="mb-0" style="font-weight: 600; font-size: 1.6rem;" >
                        <span v-if="product && cuponValid"> {{ product.total_amount ? product.total_amount : 0 | toFixedNoRounding }} € </span>
                        <span v-else-if="product"> {{ product.amount ? product.amount : 0 | toFixedNoRounding }} € </span>
                        </p>
                      </CCol>

                    </CRow>
                    <!-- Impuestos incluidos -->

                    <div v-if="product" class="mt-2 text-primary text-right">
                     <small> Impuestos incluidos</small>  </div>


                    <!-- <div class="mt-2 text-primary text-left">
                      <div class="terms-container">
                        <form
                          style="width:100%;"
                          id="form_delivery_conditions"
                          data-vv-scope="new-product">

                            <div class="text-left">
                              <input
                              v-model="checkPrivacy"
                              class="styled-checkbox"
                              id="privacy"
                              type="checkbox"
                              name="check_privacy"
                              style="display: none;"
                              v-validate="'required'"
                              data-vv-validate-on="change"
                              v-bind:invalid-feedback="errors.first('new-product.check_privacy')"
                              :class="{ 'is-invalid error': errors.first('new-product.check_privacy') }"
                              />

                              <label for="privacy" style="word-wrap:break-word;">
                                <b>ENTIENDO Y ACEPTO</b> el tratamiento de mis datos tal y como se describe anteriormente y
                                se explica con mayor detalle en la <a class="link-terms" href="https://mimotoparking.com/politica-privacidad/"
                                  target="_blank">política de privacidad.
                                </a> (Su negativa a facilitarnos la autorización implicará la imposibilidad de tratar sus datos con la finalidad
                                indicada).
                              </label>

                              <small v-if="errors.first('new-product.check_privacy')">
                                <p class="text-danger animated slideInDown faster">Debe aceptar la política de privacidad.</p>
                              </small>

                            </div>

                            <div class="text-left">

                              <input
                              v-model="checkConditions"
                              class="styled-checkbox"
                              id="condiciones"
                              type="checkbox"
                              name="check_conditions"
                              style="display: none;"
                              v-validate="'required'"
                              data-vv-validate-on="change"
                              v-bind:invalid-feedback="errors.first('new-product.check_conditions')"
                              :class="{ 'is-invalid error': errors.first('new-product.check_conditions') }"
                              />

                              <label for="condiciones" style="word-wrap:break-word;"><b>ENTIENDO Y ACEPTO</b> los <a class="link-terms"
                                  href="https://mimotoparking.com/condiciones-contrato/" target="_blank">términos y condiciones</a> tal y como se
                                describe anteriormente y se explica con mayor detalle.</label>

                              <small v-if="errors.first('new-product.check_conditions')">
                                <p class="text-danger animated slideInDown faster">Debe aceptar los términos y condiciones.</p>
                              </small>

                            </div>

                        </form>
                      </div>
                    </div> -->

                  </article>


                </CCol>

              </CRow>

            <!-- </div> -->





          </CCol>
        </CRow>


        <p class="invalid-feedback d-block mt-4 mb-3">
          {{ message }}
        </p>


        <div class="mt-4 legal">

          <b>Información básica en protección de datos:</b>
          Conforme al RGPD y la LOPDGDD, MIMOTO PARKING SL tratará los datos facilitados con la finalidad el servicio prestado.
          Siempre que nos lo autorice previamente, enviaremos información relacionada con la actividad ofrecida por MIMOTO PARKING SL.
          Podrá ejercer, si lo desea, los derechos de acceso, rectificación, supresión, y demás reconocidos en la normativa mencionada.
          Para obtener más información acerca de cómo estamos tratando sus datos, acceda a nuestra <a
            class="link-terms" href="https://mimotoparking.com/politica-privacidad/" target="_blank">política de
            privacidad.</a>

        </div>


       <toast ref="toast"></toast>

      </CCardBody>
    </CCard>


    <div class="title-container mb-3 btn-new-delivery">

      <small v-if="product && product.id" class="d-flex justify-content-center text-primary text-center">
        Pedido ya abonado, vuelve al paso uno para un nuevo envío.
      </small>

      <small v-if="!product" class="d-flex justify-content-center text-primary text-center">
        No hay pedido para abonar. Vuelve al paso 1 para seleccionar las direcciones de recogida y envío
      </small>

      <small v-if="!clientCards.length > 0" class="d-flex justify-content-center text-primary text-center">
        Añade una tarjeta para abonar el importe
      </small>


      <button @click.prevent="saveDelivery" class="btn-login-custom btn" :disabled="(product && product.id) || !product || !clientCards.length > 0">
        Pagar
      </button>

      <!-- <spinner-circle :show="loading"></spinner-circle> -->
      <spinner-ttt :show="loading"></spinner-ttt>

    </div>

    <div v-html="formSanitized"></div>


    <!-- <div class="title-container mb-3 btn-new-delivery">
      <button @click.prevent="saveDelivery" class="btn-login-custom btn" >
        Pagar
      </button>
    </div>

    <spinner-circle :show="loading"></spinner-circle> -->


    </div>
  </transition>
</template>

<script>
import validator from "@/validator";

import { CALENDAR_LANG, STATUS_REGISTERED, STATUS_REGISTERED_NO_ACCESS, STATUS_WAITING_CREDIT_CARD } from "@/config";
import { getCardLast4 } from '@/app/shared/utils/utils';

import { fetchOneParking } from '@/app/shared/global/services/parking-service';
import { payProduct, getProductStore, setProductStore } from "@/app/shared/global/services/product-service";
// import { newCardClient } from '@/app/views/clientes/shared/services';
import { newCardClient } from '@/app/shared/global/services/client-service';

export default {
  name: "DetallePlanPayment",
  props: {
    plan: { type: Object, default() {return {}}, required: true },
    parkingPlan: { type: Object, default() {return {}},required: true },
    client: { type: Object, default() {return {}},required: true },
  },
  data() {
    return {
      step: 2,
      elemento: "Pasarela de pago",
      loading: false,
      message: null,

      product: {
        clients_id: localStorage.getItem('user_id'),
        towns_id: null, // solo para ir hacia a trás
        parkings_id: null,
        plans_id: null, // plans
        start_datetime: null,
        end_datetime: null,
        dates: [],
        hours:[],

      },

      errorDates: false,
      lang: CALENDAR_LANG,

      contractPlanApi: null,

      errorPlan: false,

      parkings: [],
      planes: [],
      parking: null,
      price_hour: null,

      // client: null,
      // clientCards: [],
      card: null,
      showModalAddCard: false,
      formSanitized: null,
      timeout: null,
      modalCreditCardResponse: false,
      creditErrorResponse: false,
      modalCreditCardResponseError: false,

      cuponDescuento: '',
      cuponValid: false,
      cuponError: false,
      cuponAmount: 0,
      coupon: null,
      clientCoupons: [],

      checkPrivacy: false,
      checkConditions: false,
      getCardLast4: getCardLast4




    };
  },
  created() {
    this.getPlanBase();
    // this.getCoupons();

    this.cuponValid = this.client?.group ? true : false;

  },
  mounted(){

    this.$emit("updateStep", this);
    this.$emit("showButtons", false);

    if (getProductStore()){
      this.setDataLocalStorage();
    }

  },

  computed: {

    productItem: function () {
      return {...this.parkingPlan}
    },

    clientCards: function() {

      if (this.client) {
        let cards = this.client.credit_cards;

        cards.forEach( card => {
          card.checked = card.default ? true : false
          return card
        });

        if (cards.length == 1) {
          cards[0].checked = true;
        }

        return cards
      } else {
        return []
      }

    },

    NOACCESS() {
      // return this.client?.status.includes(STATUS_REGISTERED_NO_ACCESS, STATUS_WAITING_CREDIT_CARD);
      return this.client && this.client.status !== STATUS_REGISTERED;
    }
  },

  methods: {
    async getPlanBase() {
      try {
      const resp = await fetchOneParking(this.parkingPlan.parkings_id);
      if (resp.status == "success") {
        this.price_hour = (resp.data.plans.find(p=>p.id=1).price_per_minute * 60).toFixed(2);
        this.parking = resp.data;
        }
      } catch (e) {
        console.log(e);
        if (e?.data?.message.includes('not found')) {
          this.$refs.toast.showToast(`Parking no encontrado. Eliminado de la plataforma`, null, "warn", "5000");
          this.$router.go(-1);
          return;
        }
      }
    },
    getCoupons() {

      // fetchCoupons().then(resp => {

      //   if (resp.status !== 'success') {
      //     return
      //   }

      //   this.clientCoupons = resp.data;

      // }).catch(e => {
      //   console.log(e);
      //   // this.$refs.toast.showToast( ``, null, "warn", "5000");
      // });

    },


    applyCoupon() {

      // couponValidate({code: this.cuponDescuento}).then(resp => {

      //   if (resp?.status !== 'success') {
      //     this.cuponValid = false
      //     this.cuponError = true
      //     return
      //   }

      //   if (!this.product) {
      //     return
      //   }

      //   this.coupon = resp.data;
      //   this.product.coupons_id = resp.data.id;

      //   this.calculteCoupon(resp.data);

      //   this.cuponValid = true;
      //   this.cuponError = false;

      // })
      // .catch(e => {
      //   console.log(e);
      //   this.cuponValid = false
      //   this.cuponError = true
      // });

    },

    calculteCoupon( data ) {

      // type: "PORCENTUAL"
      // value: 100

      const cuponValue = data.value;

      if (data.type === 'PORCENTUAL') {

        const totalDiscount = this.product.amount * (cuponValue / 100)
        this.cuponAmount = totalDiscount;

      } else {

        this.cuponAmount = cuponValue;
      }

      const total = this.product.amount - this.cuponAmount;
      this.product.total_amount = total >= 0 ? total : 0;

    },

    saveDelivery() {

      this.$validator.validateAll('new-product').then( async (valid) => {

        //  if (this.product.dates.length <= 0 || this.product.dates.some(date => date === null))
        if ( !this.product.start_datetime || !this.product.end_datetime) {
          this.message = `Debes indicar el rango de fechas que aplicará el ${this.element}`;
          this.errorDates = true;
        }

        if (valid ) {

          this.loading = true;
          const errorMessage = 'Error al procesar el pago';

          try {

            //  const deliveryAmount = this.cuponValid ? this.product.total_amount : this.product.amount

            if (!this.card) {
              this.card = this.clientCards.find(c => c.checked ? c.checked : c.default ).id;
            }

            const contractToPay = {
              product: { ...this.product },  // , amount: deliveryAmount
              product_type: "parkings_plans_clients",
              clients_cards_id: this.card
            }

            let resp = await payProduct(contractToPay);

            if (resp?.status !== "success" || !resp ) {
              this.$refs.toast.showToast(`${errorMessage}`,null,"error","5000");
              this.message = `${errorMessage}. Reintenta el envío en unos minutos.`

              // Redirecct pagos?
              return
            }

            this.contractPlanApi = { ...contractToPay };
            this.contractPlanApi.id = resp.data.id;

            this.$refs.toast.showToast("Plan pagado correctamente",null,"success","5000");
            this.nextStep();

          } catch (e) {

            let errorPlan = '';
            if(e?.data?.message) {
              errorPlan = e.data.message;
            }

            this.$refs.toast.showToast(`${errorMessage}`, null, 'error', '2000');
            this.message = `${errorMessage}. ${errorPlan? errorPlan + '.': ''} Reintenta el envío en unos minutos.`
          } finally {
            this.loading = false;
          }

        } else {
          this.$refs.toast.showToast("Todos los campos son requeridos",null,"error","5000");
          this.message = 'Debes completar los campos requeridos para completar el pedido';
        }
      })
    },

    setDataLocalStorage() {

      const errorMessage = `Se ha producido un error al obtener los datos en curso`;
      this.loading = true;

      try {
        let storedData = getProductStore();

        if (storedData) {

          this.timeout = setTimeout(() => {

            if (storedData) {
              this.product = { ...storedData };

              this.cuponAmount = this.product?.discount_amount;
            }

          }, 1000);
        }

      } catch (e) {
        console.log(e);
        // this.$refs.toast.showToast(`${errorMessage}`,null,"warn","5000");
      } finally {
        this.loading = false;
      }

    },

    saveDataLocalStorage() {
      setProductStore(this.contractPlanApi);
    },


    nextStep() {

      this.loading = true;
      this.saveDataLocalStorage();

      const data = { valid: true, parkingId: this.contractPlanApi.parkings_id }

      this.$emit("validForm", data );
      this.loading = false;

    },


    setCard(value) {
      this.card = value.id;
    },


    newCreditCard() {
      this.showModalAddCard = false;

      this.message = null;
      const errorMessage = `Se ha producido un error al procesar la conexión con la pasarela`;

      newCardClient(this.client.id, 'CP').then( resp => {

        if (resp.status !== "success") {
          this.$refs.toast.showToast('Error, inténtalo de nuevo en unos minutos', null, 'error', '5000');
          return
        }

        this.formSanitized = resp.data; //this.cleanMessage(resp.data);

        this.$nextTick(() => {
          const formElement = document.getElementById('mimoto_payment_form');
          formElement.submit();
        });

        // window.location.href = resp.data.URL_REDIRECT;
        // window.open(resp.data.URL_REDIRECT);

      }).catch(e => {
        this.$refs.toast.showToast(`${errorMessage}`,null,"error","5000");
        this.message = `${errorMessage}. Inténtalo de nuevo en unos minutos`
        console.log(e);
      });



      // newCardClient('DESDE_PEDIDO').then( redsysForm => {

      //   this.formSanitized = redsysForm; // this.$sanitize(redsysForm);

      //   this.timeout = setTimeout(() => {
      //     const formElement = document.getElementById('redsys_uimove_form');
      //     formElement.submit();
      //   });

      //   this.getClient();

      // }).catch(e => {
      //   console.log(e);
      //   this.$refs.toast.showToast(`${errorMessage}`,null,"error","5000");
      //   this.message = `${errorMessage}. Inténtalo de nuevo en unos minutos`
      // });

    },

  }
};
</script>

<style lang="scss" scoped>


.input-group-append {
  .input-group-text {
    color: #1c1f22; //#5c6873;
    background-color: var(--theme-color-primary)!important;// #f0f3f5; //
    border-color: var(--theme-color-primary); //#e4e7ea;
  }
}


#delivery_name {
  border-top-style: hidden;
  border-right-style: hidden;
  border-left-style: hidden;
  border-bottom-style: groove;
  background-color: ffffff;
  border-bottom: 1px solid #e4e7ea;
  width: 100%;
  &::placeholder {
   font-style: italic;
  }

  &:focus {
    border-bottom: 1px solid var(--theme-color-primary);
  }
}

.no-outline:focus {
  outline: none;
}


.cart__checkout {
  border-top: 1px solid #e1e1e1;
  // border-bottom: 1px solid #e1e1e1;
  // margin-bottom: 25.6px;
  margin-bottom: 1.6rem;
  // padding-top: 25.6px;
  padding-top: 1.6rem;

  @media (min-width: 48em) {
    margin-bottom: 2rem;
    padding-top: 2rem;
  }
}

.alert-space {
  // border: 1px solid rgba(208,0,0,.15) !important;
  margin: 14px 0 16px;
  padding: 16px;
  padding: 1.6rem;
}

.checkout-by-steps-cart-price {
  // margin-bottom: 25.6px;
  // margin-bottom: 1.6rem;

  &--total {
    // font-size: 32px;
    font-size: 1.7rem;

  }
}

.checkout-by-steps-sidebar__content {

  // padding-left: 1.2rem;
  // padding-top: 102.4px;
  padding-left: 19.2px;
  padding-top: 1.4rem;

  background: #f9fafa;
  // background-color: lighten(#F7EACF, 10) ;


  @media (min-width: 75em){
    padding-right: 0;
  }


  @media (min-width: 62em) {
    padding-left: 3.2rem;
    padding-right: 2.4rem;
  }

  @media (max-width: 1000px) {
    padding-left: 15px;
    padding-right:  15px;
  }

}
.checkout-by-steps-main__content {

  @media (min-width: 62em) {
    padding-left: 2.4rem;
    padding-right: 3.2rem;
  }

  @media (max-width: 1000px) {
    padding-left: 15px;
    padding-right:  15px;
  }

}

.legal {
  font-size: 12px;
  font-family: "MuseoSans-300";
  color: #7a7a7a;
  text-align: left;
}



</style>
